export const getMultilineLabel = (key: string): string[] => {
  const [first, ...rest] = key.split(' ');
  return [first, rest.join(' ')];
};